module.exports = __webpack_public_path__ + "static/img/midcb2.9ea2c317.png";